import { render, staticRenderFns } from "./NewOrderDentate.vue?vue&type=template&id=d74e9986"
import script from "./NewOrderDentate.vue?vue&type=script&lang=js"
export * from "./NewOrderDentate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports